import { Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Box } from '@mui/material';

import CancelButton from 'src/careflow/common/CancelButton';
import { CustomLoadingButton } from 'src/careflow/common/CustomButton';
import CloseIconButton from 'src/components/CloseIconButton';

export interface ConfirmDialogProps extends Omit<DialogProps, 'onClose'> {
  onConfirm: () => void;
  onDialogClose: () => void;
  dialogTitle?: string;
  confirmButtonTitle?: string;
  ConfirmButtonIcon?: React.ReactNode;
  isLoading?: boolean;
  showCloseButton?: boolean;
}

const ConfirmDialog = ({
  onConfirm,
  children,
  onDialogClose,
  ConfirmButtonIcon,
  confirmButtonTitle = 'Confirm',
  dialogTitle = 'Confirmation',
  isLoading,
  showCloseButton = true,
  ...dialogProps
}: ConfirmDialogProps) => (
  <Dialog
    onClose={() => {
      onDialogClose();
    }}
    {...dialogProps}
  >
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <DialogTitle sx={{ flex: 1 }}>{dialogTitle}</DialogTitle>
      {showCloseButton && (
        <Box sx={{ pr: 2 }}>
          <CloseIconButton
            onClick={onDialogClose}
            disabled={!!isLoading}
            data-name="confirm-dialog-close-button"
          />
        </Box>
      )}
    </Box>
    <DialogContent>{children}</DialogContent>
    <DialogActions>
      <CustomLoadingButton
        variant="contained"
        onClick={() => {
          onConfirm();
        }}
        startIcon={ConfirmButtonIcon}
        color="primary"
        loading={!!isLoading}
        disabled={!!isLoading}
      >
        {confirmButtonTitle}
      </CustomLoadingButton>
      <CancelButton
        onClick={() => {
          onDialogClose();
        }}
      />
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
